import React, { useEffect, useState, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";

var tempTigger;

export default function FirmwareStore(props) {
  const history = useHistory();
  const [FotaListData, setFotaListData] = useState([]);
  const [FotaCountData, setFotaCountData] = useState([]);

  const viewFirmwareHandle = (data) => {
    history.push({
      pathname: "/Fota/ViewFirmware/" + data?.row?.original?.firmwareID,
      state: { firmwareData: FotaData },
    });
  };

  const editFirmwareHandle = (data) => {
    history.push({
      pathname: "/Fota/editFirmware/" + data?.row?.original?.firmwareID,
      state: { firmwareData: FotaData },
    });
  };

  useEffect(() => {
    tempTigger = !history?.location?.compomentRenderType
      ? "init"
      : history?.location?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.compomentRenderType === "view"
      ? "view"
      : "amhitted";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  const FotaData = [
    {
      firmwareID: "perf",
      releasedOn: "20/02/2023",
      make: "Amaron",
      model: "Amaron",
      size: "10 MB",
      version: "V 2.4",
      action: "XXXXX",
    },
    {
      firmwareID: "test",
      releasedOn: "02/07/2023",
      make: "Exicom",
      model: "Exicom",
      size: "50 MB",
      version: "V 1.6",
      action: "XXXXX",
    },
    {
      firmwareID: "test1",
      releasedOn: "14/03/2023",
      make: "Exicom",
      model: "Exicom",
      size: "30 MB",
      version: "V 2.7",
      action: "XXXXX",
    },
    {
      firmwareID: "test2",
      releasedOn: "19/08/2023",
      make: "Amaron",
      model: "Amaron",
      size: "20 MB",
      version: "V 1.5",
      action: "XXXXX",
    },
    {
      firmwareID: "test3",
      releasedOn: "22/05/2023",
      make: "Amaron",
      model: "Amaron",
      size: "40 MB",
      version: "V 1.0",
      action: "XXXXX",
    },
    {
      firmwareID: "test4",
      releasedOn: "05/04/2023",
      make: "Exicom",
      model: "Exicom",
      size: "10 MB",
      version: "V 2.5",
      action: "XXXXX",
    },
    {
      firmwareID: "test5",
      releasedOn: "03/06/2023",
      make: "Amaron",
      model: "Amaron",
      size: "50 MB",
      version: "V 2.0",
      action: "XXXXX",
    },
    {
      firmwareID: "test6",
      releasedOn: "09/08/2023",
      make: "Amaron",
      model: "Amaron",
      size: "40 MB",
      version: "V 1.5",
      action: "XXXXX",
    },
    {
      firmwareID: "test7",
      releasedOn: "25/12/2023",
      make: "Amaron",
      model: "Amaron",
      size: "20 MB",
      version: "V 2.5",
      action: "XXXXX",
    },
  ];

  const getFotaList = useCallback(async (searchString) => {
    const filteredData = FotaData.filter((item) =>
      item.firmwareID.toLowerCase().includes(searchString.toLowerCase())
    );

    return Promise.resolve(filteredData);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    // getPriceList();
    setFotaListData(FotaData);
    setFotaCountData(FotaData.length);
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "Firmware ID",
      accessor: "firmwareID",
      // width: "40%",
    },
    {
      Header: "Released On",
      accessor: "releasedOn",
      // width: "30%",
    },
    {
      Header: "Make",
      accessor: "make",
    },
    {
      Header: "Model",
      accessor: "model",
      // width: "40%",
    },
    {
      Header: "Size",
      accessor: "size",
      // width: "40%",
    },
    {
      Header: "Firmware Version",
      accessor: "version",
      // width: "40%",
    },
    {
      Header: "Action",
      accessor: "action",
      // width: "40%",
      Cell: (row) => {
        return (
          <>
            <div>
              <img
                src={require("assets/pencil.png").default}
                style={{ cursor: "pointer" }}
                onClick={() => editFirmwareHandle(row)}
              ></img>
              <img
                src={require("assets/eye.png").default}
                style={{ margin: "8px", cursor: "pointer" }}
                onClick={() => viewFirmwareHandle(row)}
              ></img>
            </div>
          </>
        );
      },
    },
  ]);

  var searchByKey = () => {};

  return (
    <>
      <NewTableAndSearchMasterFilter
        searchOpts={{
          placeholder: "Search by Firmware ID",
          filter: true,
          onFilterSearch: (searchString) => getFotaList(searchString),
          screentype: "FirmwareStore",
        }}
        tigger={tempTigger}
        columns={columns}
        data={FotaListData}
        paginationDoubleScreen={true}
        swapStationCount={FotaCountData}
        FilterOpts={"FirmwareStore"}
      />
      {/* </div> */}
    </>
  );
}

FirmwareStore.inStorybook = true;
